<template>

    <main v-if="auth.type === 'admin'">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body" style="min-height: 900px;" v-if="fetcher.initialized">

            <div class="container-fluid">
                <h1>{{ pageTitle }}</h1>
            </div>

            <div class="card-viewport mt-10 mb-16">
                <div class="card-container">
                    <div class="container-fluid">
                        <div class="row g-3 g-md-5">
                            <div class="col-8 col-md-12 col-lg-8 mb-6 mb-md-0">
                                <div class="card">
                                    <div class="pre-line">Abonnemang</div>
                                    <h2 v-if="contractInfo">
                                        {{ contractInfo.subscription.name_public }}
                                    </h2>
                                </div>
                            </div>
                            <div class="col-8 col-md-12 col-lg-8 mb-6 mb-md-0">

                                <div class="card" v-if="contractInfo.subscription.type !== 'pay_per_treatment'">
                                    <div class="pre-line">Månadskostnad</div>

                                    <h2 v-if="priceInfo">{{ priceInfo.monthly_cost }} kr</h2>

                                    <p class="small" v-if="contractInfo.subscription.type === 'dynamic_period'">
                                        Löpande med {{ contractInfo.subscription.num_months_notice_period }} månaders uppsägningstid.
                                        Inkluderar max {{ contractInfo.subscription.num_treatments }} behandlingar per {{ contractInfo.subscription.num_months_binding }} mån
                                        <br>Behandlingslängd {{ contractInfo.subscription.duration.minutes }} min. <span v-if="contractInfo.start_fee > 0">Startavgift {{ contractInfo.start_fee }} kr.</span>
                                    </p>

                                    <p class="small" v-if="contractInfo.subscription.type === 'binding_period'">
                                        Avtalsperiod 12 månader med {{ contractInfo.subscription.num_months_notice_period }} månaders uppsägningstid.
                                        Inkluderar max {{ contractInfo.subscription.num_treatments }} behandlingar.
                                        <br>Behandlingslängd {{ contractInfo.subscription.duration.minutes }} min. <span v-if="contractInfo.start_fee > 0">Startavgift {{ contractInfo.start_fee }} kr.</span> Avtalet löper ut {{ contractInfo.next_renewal_at }}.
                                    </p>
                                </div>

                                <div class="card" v-if="contractInfo.subscription.type === 'pay_per_treatment'">
                                    <div class="pre-line">Behandlingskostnad</div>
                                    <p class="text-primary">
                                        <span v-if="contractInfo.subscription.external && priceInfo">
                                            På arbetsplatsen: {{ priceInfo.external_treatment_cost }} kr<br>
                                        </span>
                                        <span v-if="contractInfo.subscription.internal && priceInfo">
                                            På mottagning: {{ priceInfo.internal_treatment_cost }} kr
                                        </span>
                                    </p>
                                    <p class="small">{{ contractInfo.subscription.num_months_notice_period }} månaders uppsägningstid.<br>Behandlingslängd {{ contractInfo.subscription.duration.minutes }} min. <span v-if="contractInfo.start_fee > 0">Startavgift {{ contractInfo.start_fee }} kr.</span></p>
                                </div>
                            </div>
                            <div class="col-8 col-md-12 col-lg-8 mb-6 mb-md-0">
                                <div class="card">

                                    <div v-if="active_contract && pending_contract">

                                        <div class="pre-line">Aktivt avtal</div>

                                        <a :href="'/data/billing/contract/'+active_contract.id+'/download'" target="_blank">
                                            <h2 class="mt-md-0">
                                                <img class="download-icon" src="/images/company-portal/icon-download.svg">
                                                Ladda ner
                                            </h2>
                                        </a>
                                        <p class="pre-line mb-1 mt-4 pt-3" style="border-top:1px solid #efefef;">Nytt avtal från {{ pending_contract.starts_at }}:</p>
                                        <a :href="'/data/billing/contract/'+pending_contract.id+'/download'" target="_blank">
                                            <h3 class="mt-0">
                                                <img class="download-icon" src="/images/company-portal/icon-download.svg">
                                                Ladda ner
                                            </h3>
                                        </a>
                                    </div>

                                    <div v-if="active_contract && !pending_contract">

                                        <div class="pre-line">Avtal</div>

                                        <a :href="'/data/billing/contract/'+active_contract.id+'/download'" target="_blank">
                                            <h2 class="mt-md-7">
                                                <img class="download-icon" src="/images/company-portal/icon-download.svg">
                                                Ladda ner
                                            </h2>
                                        </a>

                                    </div>

                                    <div v-if="!active_contract && pending_contract">

                                        <div class="pre-line">Avtal</div>

                                        <a :href="'/data/billing/contract/'+pending_contract.id+'/download'" target="_blank">
                                            <h2 class="mt-md-7">
                                                <img class="download-icon" src="/images/company-portal/icon-download.svg">
                                                Ladda ner
                                            </h2>
                                        </a>

                                    </div>

                                    <div v-if="previous_contract && !active_contract && !pending_contract">

                                        <div class="pre-line">Avtal</div>

                                        <a :href="'/data/billing/contract/'+previous_contract.id+'/download'" target="_blank">
                                            <h2 class="mt-md-7">
                                                <img class="download-icon" src="/images/company-portal/icon-download.svg">
                                                Ladda ner
                                            </h2>
                                        </a>

                                    </div>

                                    <p class="pre-line text-warning" v-if="active_contract && active_contract.ends_at && !pending_contract">Avtalet är uppsagt och utgår {{ active_contract.ends_at }}</p>
                                    <p class="pre-line text-warning" v-if="previous_contract && !active_contract">Avtalet avslutades {{ previous_contract.ends_at }}</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid">

                <h2>Historik</h2>

                <div class="row mb-5 pt-2">
                    <div class="col col-md-10 col-lg-6">
                        <select class="form-select form-select-sm form-control-list" v-model="settings.query.year">
                            <option :value="null">Välj år</option>
                            <option :key="'y'+year" v-for="year in filterYears">{{ year }}</option>
                        </select>
                    </div>
                </div>

                <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false" :showHeader="false">
                    <div slot="item-row" slot-scope="props">
                        <list-item-row :item="props.item" :show_workplace_fee_text="show_workplace_fee_text" />
                    </div>
                </list>

            </div>

        </div>

    </main>

</template>

<script>
import moment from 'moment'

import scrollMixin from '../../../shared/mixins/scrollMixin'
import lister from '../../../shared/mixins/lister'
import fetcher from '../../../shared/mixins/fetcher'

import ListItemRow from './list-row-item'

import { activeContract, pendingContract, previousContract } from '../../../shared/methods/contract-filter'

export default {
    components: { ListItemRow },
    mixins: [
        scrollMixin,
        lister,
        fetcher
    ],

    data () {
        return {
            pageTitle: 'Abonnemang',
            foldRow: false,
            company: null,
            contracts: [],
            active_contract: null,
            previous_contract: null,
            pending_contract: null,
            active_price_period: null,
            previous_price_period: null,
            pending_price_period: null,
            first_contract_starts_at: null,
            show_workplace_fee_text: false,
            fetcher: {
                autoFill: [
                    'company',
                    'active_contract',
                    'previous_contract',
                    'pending_contract',
                    'active_price_period',
                    'previous_price_period',
                    'pending_price_period',
                    'first_contract_starts_at',
                    'show_workplace_fee_text'
                ]
            },
            settings: {
                url: '/data/billing/list',
                query: {
                    year: null
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col-3', sortable: false, default: true }
                ],
                bulk_actions: []
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/billing'
        },

        filterYears () {
            const years = []
            if (!this.first_contract_starts_at) {
                return years
            }

            const date = moment(this.first_contract_starts_at)
            while (date.isBefore(moment())) {
                years.push(date.year())
                date.add(1, 'year')
            }

            return years
        },

        contractInfo () {
            if (this.active_contract) {
                return this.active_contract
            } else if (this.pending_contract) {
                return this.pending_contract
            } else if (this.previous_contract) {
                return this.previous_contract
            }
        },

        priceInfo () {
            if (this.active_price_period) {
                return this.active_price_period
            } else if (this.pending_price_period) {
                return this.pending_price_period
            } else if (this.previous_price_period) {
                return this.previous_price_period
            }
        }

    },

    methods: {

        activeContract: activeContract,

        pendingContract: pendingContract,

        previousContract: previousContract

    }
}
</script>
